import React from "react";
import BreadCrumb from "../src/components/Shared/BreadCrumb";
import server from "../src/api/server";
import { useIntl } from "react-intl";
import Hiring from "../src/components/Hiring/index";
import { NextSeo } from "next-seo";

const HiringPage = ({ breadBackground, metaDataSections }) => {
  const { formatMessage, locale } = useIntl();
  const hiringMeta = metaDataSections?.find((item) => item?.slug === "hiring");
  return (
    <>
      <NextSeo
        title={null || formatMessage({ id: hiringMeta?.slug })}
        description={
          hiringMeta?.description[locale] ||
          formatMessage({ id: "Walid Ben Abdulaziz Ben mouzan" })
        }
        additionalMetaTags={[
          {
            name: "keywords",
            content: "",
          },
          {
            name: "description",
            content: "",
          },
        ]}
      />
      <div className="hiring-page">
        <BreadCrumb
          title={formatMessage({ id: "hiring" })}
          pageTitle={formatMessage({ id: "hiring" })}
          breadBackground={breadBackground}
        />
        <Hiring
          formTitle={formatMessage({ id: "askPartner" })}
          formSubtitle={formatMessage({ id: "joinUs" })}
        />
      </div>
    </>
  );
};

export const getStaticProps = async (ctx) => {
  try {
    const backgroundResponse = await server.get("/pages/backgrounds");
    const metaDataResponse = await server.get("/pages/metaData");
    const breadBack = backgroundResponse?.data?.data?.page?.sections?.find(
      (sec) => sec?.slug === "breadcrumbs"
    )?.image;

    return {
      revalidate: 1,
      props: {
        metaDataSections: metaDataResponse?.data?.data?.page?.sections,
        breadBackground: breadBack
          ? `${process.env.NEXT_PUBLIC_MAIN_URL}/${breadBack}`
          : null,
      },
    };
  } catch (error) {
    return {
      revalidate: 1,
      props: {
        error: JSON.stringify(error),
      },
    };
  }
};

export default HiringPage;
